import React, { forwardRef } from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  containerClassName?: string;
  labelClassName?: string;
  textareaClassName?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      error,
      helperText,
      containerClassName = '',
      labelClassName = '',
      textareaClassName = '',
      id,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`space-y-2 ${containerClassName}`}>
        {label && (
          <label
            htmlFor={id}
            className={`block text-sm font-medium ${labelClassName}`}
            style={{ color: error ? '#E74C3C' : 'var(--patreon-black)' }}
          >
            {label}
          </label>
        )}

        <textarea
          ref={ref}
          id={id}
          className={`
            block w-full rounded-md border-gray-300 shadow-sm
            focus:border-[color:var(--patreon-orange)] focus:ring-[color:var(--patreon-orange)]
            disabled:bg-gray-100 disabled:border-gray-300
            ${textareaClassName}
          `}
          style={{
            background: 'var(--patreon-card-bg)',
            borderColor: error ? '#E74C3C' : 'var(--patreon-card-border)',
            color: 'var(--patreon-black)'
          }}
          {...props}
        />

        {error && (
          <p className="text-sm" style={{ color: 'var(--patreon-error)' }}>{error}</p>
        )}

        {helperText && !error && (
          <p className="text-sm" style={{ color: 'var(--patreon-gray)' }}>{helperText}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;



